<template>
  <GhostContent :slug="route.params.slug" tag="content" />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'content'
})

const route = useRoute()
</script>
